import { ManageShippingPartiesModule } from './../manage-shipping-parties/manage-shipping-parties.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LrManagementRoutingModule } from './LR-management-routing.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { UsersListComponent } from './users-list/users-list.component';
// import { AddUserComponent } from './add-user/add-user.component';
// import { EditUserComponent } from './edit-user/edit-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LRListComponent } from './lr-list/lr-list.component';
import { AddLrComponent } from './add-lr/add-lr.component';
import { EditLrComponent } from './edit-lr/edit-lr.component';
import { ViewLrComponent } from './view-lr/view-lr.component';
import { sharedModule } from 'src/app/shared/myshared.module';
//import { NgxPrintModule} from 'ngx-print';
import { EditInvoiceComponent } from './edit-invoice/edit-invoice.component';
import { AddInvoiceComponent } from './add-invoice/add-invoice.component';
import { DataTablesModule } from "angular-datatables";
import { DetailLrComponent } from './detail-lr/detail-lr.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { NewInvoiceComponent } from './new-invoice/new-invoice.component';
import { GstInvoiceComponent } from './gst-invoice/gst-invoice.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ImagePreviewComponent } from './image-preview/image-preview.component'
import { ViewsTrackerComponent } from './views-tracker/views-tracker.component';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { ViewInvoiceComponent } from './view-invoice/view-invoice.component';
import { AmountInWordsPipe } from './amount-in-words.pipe';
import { MatRadioModule } from '@angular/material/radio';
import { PODStatusComponent } from './pod-status/pod-status.component';
import { NgxPrintModule } from 'ngx-print';
import { AddfuelExpenseComponent } from './addfuel-expense/addfuel-expense.component';
import { AddDriverExpenseComponent } from './add-driver-expense/add-driver-expense.component';
import { TrackerModuleComponent } from './tracker-module/tracker-module.component';
import { AddLrModuleComponent } from './add-lr-module/add-lr-module.component';
import { EditTrackerComponent } from './edit-tracker/edit-tracker.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DetailTrackerComponent } from './detail-tracker/detail-tracker.component';
import { ViewTrackerInvoiceComponent } from './view-tracker-invoice/view-tracker-invoice.component';
import { TrackerInvoiceListComponent } from './tracker-invoice-list/tracker-invoice-list.component';
import { InvoicePreviewComponent } from './invoice-preview/invoice-preview.component';
import { InvoiceTrackerPreviewComponent } from './invoice-tracker-preview/invoice-tracker-preview.component';
// import { LightgalleryModule } from 'lightgallery/angular';


@NgModule({
  // declarations: [UsersListComponent, AddUserComponent, EditUserComponent],
  declarations: [ LRListComponent, AddLrComponent, EditLrComponent, ViewLrComponent, EditInvoiceComponent, AddInvoiceComponent, DetailLrComponent, InvoiceListComponent, NewInvoiceComponent, GstInvoiceComponent, ImagePreviewComponent, ViewsTrackerComponent, ViewInvoiceComponent, AmountInWordsPipe, PODStatusComponent, AddfuelExpenseComponent, AddDriverExpenseComponent, TrackerModuleComponent, AddLrModuleComponent, EditTrackerComponent, DetailTrackerComponent, ViewTrackerInvoiceComponent, TrackerInvoiceListComponent, InvoicePreviewComponent, InvoiceTrackerPreviewComponent],
  imports: [
   // NgxPrintModule,
    CommonModule,
    DataTablesModule,
    LrManagementRoutingModule,
    NgxChartsModule,
    ReactiveFormsModule,
    MatRadioModule,
    FormsModule,
    sharedModule,
    NgxPrintModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
    // LightgalleryModule
  ],
  providers:[],
  exports:[
    LrManagementRoutingModule
  ]
})
export class LrManagementModule { }

